export const LEARN_MORE =
  'https://docs.prebid.org/dev-docs/modules/index.html#vendor-specific-modules'
